<div *ngIf="renderingMode === ArFeatureRenderingMode.FORM">
    <aumico-fcp-form
        [domainModel]="domainModel"
        (finalizeAndContinueButtonClicked)="finalizeAndContinue()"
    ></aumico-fcp-form>
</div>
<div *ngIf="renderingMode === ArFeatureRenderingMode.PRINT_PREVIEW">
    <aumico-fcp-print-preview [domainModel]="domainModel" onlyDefaultDisplay="true"></aumico-fcp-print-preview>
</div>
